import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import { graphql, Link } from 'gatsby';
import sizes from 'react-sizes';
import { getSlug } from 'utils';
import { InView } from 'react-intersection-observer';
import {
  VenueInfo,
  ContactUs,
  PaddedMultiCarousel,
  ProgramaticallyCreatedPageOverview,
  Hero,
  HeroImg,
  SectionTitle,
  ClientTestimonialsMultiCarousel,
  SEO
} from 'components';
import PurpleTriangleYellowCircleBlobSVG from 'images/shared/misc/blobs/purple_triangle_yellow_circle.svg';
import YellowCircleBlueSwooshBlobSVG from 'images/shared/misc/blobs/yellow_circle_blue_swoosh.svg';
import YellowTriangleRedCircleSVG from 'images/shared/misc/blobs/yellow_triangle_red_circle.svg';
import LightBlueBackgroundSVG from 'images/shared/misc/light_blue_background_2.svg';
import LightPurpleBackgroundSVG from 'images/shared/misc/blobs/light_purple_background.svg';

const getServicesFilteredListItems = (activeFilter, services) => {
  const {
    teamBuilding,
    countryPursuits,
    irishActivities,
    companyAndEveningEntertainment,
    eventManagement
  } = services;

  switch (activeFilter) {
    case 'Team Building':
      return teamBuilding;
    case 'Country Pursuits':
      return countryPursuits;
    case 'Irish':
      return irishActivities;
    case 'Evening Entertainment':
      return companyAndEveningEntertainment;
    case 'Event Management':
      return eventManagement;
    default:
      return teamBuilding;
  }
};

class Venue extends PureComponent {
  state = {
    animateLightBlueBackgroundSVG: false,
    animateLightPurpleBackgroundSVG: false,
    activeFilter: 'Team Building'
  };

  componentDidMount() {
    const eventManagementBannerEC = document.querySelector('.event-management-banner-ec');
    if (eventManagementBannerEC) {
      this.props.handleEventManagementTrendsBannerLoading();
    }
  }

  handleFilterClick = (e) => {
    this.setState({
      activeFilter: e.target.innerText
    });
  };

  handleBlueBackgroundSVG = (animateLightBlueBackgroundSVG) =>
    this.setState({ animateLightBlueBackgroundSVG });

  handlePurpleBackgroundSVG = (animateLightPurpleBackgroundSVG) =>
    this.setState({ animateLightPurpleBackgroundSVG });

  render() {
    const { data, location, viewportWidth, handleHeader } = this.props;
    const { venue, cards } = data;
    const { pathname } = location;
    const {
      title,
      featuredImg,
      summary,
      carouselImgs,
      services,
      venuePartnerWebsite,
      pardotRedirectLinkForBrochure,
      specificTestimonials
    } = venue.frontmatter;

    const { animateLightBlueBackgroundSVG, animateLightPurpleBackgroundSVG, activeFilter } =
      this.state;

    // const filteredServices = getServicesFilteredListItems(activeFilter, services);

    return (
      <>
        <Hero
          title={title}
          subText={summary}
          buttonLinkPath="#contact-us"
          buttonText="Booking Enquiry"
          buttonWidth="202px"
          handleHeader={handleHeader}>
          <HeroImg heroImg={featuredImg} />
        </Hero>
        <ProgramaticallyCreatedPageOverview pathname={pathname} carouselImgs={carouselImgs}>
          <VenueInfo
            info={{
              about: venue.html
            }}
            buttonLinkPath={pardotRedirectLinkForBrochure && pardotRedirectLinkForBrochure}
            buttonText="Download Brochure"
            buttonWidth="202px"
            venuePartnerWebsite={venuePartnerWebsite}
          />
        </ProgramaticallyCreatedPageOverview>
        {services && (
          <InView onChange={this.handleBlueBackgroundSVG} triggerOnce>
            <VenueServices>
              <LightBlueBackground
                style={{ pointerEvents: 'none' }}
                alt="light blue background"
                animateLightBlueBackgroundSVG={animateLightBlueBackgroundSVG}
                animationDuration="0.75s"
                src={LightBlueBackgroundSVG}
              />
              <LightPurpleBackground
                alt="light purple background"
                animateLightPurpleBackgroundSVG={animateLightPurpleBackgroundSVG}
                animationDuration="0.75s"
                src={LightPurpleBackgroundSVG}
              />
              {viewportWidth >= 1000 && (
                <>
                  <PurpleTriangleYellowCircleBlob
                    src={PurpleTriangleYellowCircleBlobSVG}
                    alt="purple and yellow blob"
                  />
                  <YellowCircleBlueSwooshBlobSVGBlob
                    src={YellowCircleBlueSwooshBlobSVG}
                    alt="yellow and blue blob"
                  />
                  {/*  <YellowTriangleRedCircleSVGBlob
                    src={YellowTriangleRedCircleSVG}
                    alt="yellow and red blob"
                  /> */}
                </>
              )}
              {/* <VenueService>
                <SectionTitle title={`Activities and Services<br /> at ${title}`} />
                <ServiceOverview>
                  There are a variety of activities and services that we provide on-site to cater
                  for your needs. Whether it is a large or small group, we will work in conjunction
                  with the venue, to accommodate your request and exceed your expectations in terms
                  of your event. At Dynamic Events our goal is to tailor your event to best fit your
                  goals and objectives, to ensure every element of your requirements have been
                  provided for.
                </ServiceOverview>
                <ActivityAndServicesWrapper>
                  <ActivityAndServiceFilters
                    onClick={(e) => this.handleFilterClick(e)}
                    role="button"
                    tabIndex={0}>
                    <Filter active={activeFilter === 'Team Building'}>Team Building</Filter>
                    <Filter active={activeFilter === 'Country Pursuits'}>Country Pursuits</Filter>
                    <Filter active={activeFilter === 'Irish'}>Irish</Filter>
                    <Filter active={activeFilter === 'Evening Entertainment'}>
                      Evening Entertainment
                    </Filter>
                    <Filter active={activeFilter === 'Event Management'}>Event Management</Filter>
                  </ActivityAndServiceFilters>
                  {filteredServices.length > 0 ? (
                    <ActivityAndServiceList filteredServices={filteredServices}>
                      {filteredServices.map((listItem) => (
                        <Link
                          key={listItem}
                          to={`${
                            activeFilter === 'Event Management'
                              ? '/event-management/'
                              : '/team-building/'
                          }${getSlug(listItem)/}`}>
                          <li>{listItem}</li>
                        </Link>
                      ))}
                    </ActivityAndServiceList>
                  ) : (
                    <PleaseChooseAnotherFilter>
                      Please choose another filter
                    </PleaseChooseAnotherFilter>
                  )}
                </ActivityAndServicesWrapper>
              </VenueService> */}
            </VenueServices>
          </InView>
        )}
        <ClientTestimonialsMultiCarousel
          specificTestimonials={specificTestimonials}
          paddingStyle="42px 3.2% 62px"
          pathname={pathname}
        />
        <PaddedMultiCarousel
          pathname={pathname}
          paddingStyle={`${viewportWidth < 1100 ? '280px' : '165px'} 3.2% 0`}
          title="Other Venues"
          cards={cards}
        />
        <ContactUs location={location} />
      </>
    );
  }
}

export const Head = ({ data, location }) => {
  const { frontmatter } = data.venue;
  return (
    <SEO
      pageSpecificTitle={
        frontmatter.metaTagOverrides?.title ? frontmatter.metaTagOverrides.title : frontmatter.title
      }
      pageSpecificDescription={
        frontmatter.metaTagOverrides?.description
          ? frontmatter.metaTagOverrides.description
          : frontmatter.summary
      }
      pageSpecificThumbnail={
        data.venue.frontmatter.featuredImg.src.childImageSharp.gatsbyImageData.images.fallback.src
      }
      pageSpecificThumbnailAlt={data.venue.frontmatter.featuredImg.src.name.replace(/-|_/g, ' ')}
      pathname={location.pathname}
    />
  );
};

const PleaseChooseAnotherFilter = styled.p`
  color: var(--dynamic-blue);
  font-family: adelle, serif;
  font-size: 2rem;
  letter-spacing: 0.01em;
  margin: 0.5rem auto 0;
  text-align: center;
`;

const VenueServices = styled.section`
  position: relative;
  margin-top: 180px;
  padding: 0 3.2%;
`;

const ActivityAndServiceFilters = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 auto 1.5em;
  flex-wrap: wrap;
  flex-shrink: 1;

  @media screen and (min-width: 880px) {
    max-width: 746px;
    justify-content: space-between;
  }
`;

const Filter = styled.button`
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid var(--dynamic-blue);
  color: var(--dynamic-blue);
  cursor: pointer;
  font-family: 'proxima-nova', sans-serif;
  font-size: 0.95rem;
  outline: none;
  padding: 0.525em 0.9em;
  max-width: 153px;
  width: 100%;
  letter-spacing: 0.01em;
  margin: 2.5px;
  height: 58.78px;

  @media screen and (min-width: 500px) {
    max-width: 159px;
    font-size: 1rem;
  }

  @media screen and (min-width: 880px) {
    width: initial;
    margin: initial;
    height: initial;
  }

  &:hover {
    background-color: rgba(77, 177, 232, 0.15);
  }

  ${({ active }) =>
    active &&
    css`
      animation: filterClickAnimation 0.225s ease-in-out forwards;
      background-color: var(--dynamic-blue);
      color: #fff;

      &:hover {
        background-color: var(--dynamic-blue);
      }
    `};

  @keyframes filterClickAnimation {
    0% {
      transform: scale3d(1, 1, 1);
    }

    40% {
      transform: scale3d(0.8, 0.8, 0.8);
    }

    60% {
      transform: scale3d(0.8, 0.8, 0.8);
    }

    100% {
      transform: scale3d(1, 1, 1);
    }
  }
`;

const VenueService = styled.section`
  margin: 0 auto;
  max-width: 820px;
`;

const ServiceOverview = styled.p`
  color: var(--dynamic-dark-grey);
  margin: 4.878048780487805% auto 6.097560975609756%;
  text-align: center;
  line-height: 1.313em;
`;

const ActivityAndServicesWrapper = styled.div`
  background: #fff;
  box-shadow: 7px 7px 16px rgba(189, 189, 189, 0.3);
  border-radius: 10px;
  padding: 10px 10px 1.25em;
  margin-bottom: 10.731707317073171%;
  display: flex;
  flex-direction: column;
  align-items: space-evenly;
  justify-content: center;

  @media screen and (min-width: 500px) {
    padding: 2em 2em 2.5em;
  }
`;

const ActivityAndServiceList = styled.ul`
  column-count: 1;
  list-style: none;
  position: relative;
  top: 0.625em;
  margin: 0 auto;

  @media screen and (min-width: 500px) {
    column-count: 2;
  }

  @media screen and (min-width: 820px) {
    column-count: 3;
  }

  ${({ filteredServices }) =>
    filteredServices.length === 1
      ? 'column-count: 1 !important;'
      : filteredServices.length === 2 || filteredServices.length === 4
      ? 'column-count: 2 !important;'
      : filteredServices.length === 3
      ? 'column-count: 3 !important;'
      : ''};

  a {
    color: var(--dynamic-blue);
  }

  li {
    color: var(--dynamic-blue);
    font-family: 'proxima-nova', sans-serif;
    font-size: 1.25rem;
    margin: 0 1em 0.85em;
    text-align: center;
    line-height: 1.15em;
    max-width: 10em;

    &:hover {
      color: var(--dynamic-dark-blue);
    }
  }
`;

const LightBlueBackground = styled.img`
  position: absolute;
  top: -200px;
  transform: translate3d(-150%, 0, 0);
  width: 120%;
  margin-left: 50%;

  ${({ animateLightBlueBackgroundSVG, animationDuration }) =>
    animateLightBlueBackgroundSVG &&
    css`
      transform: translate3d(-50%, 0, 0);
      transition: transform ${animationDuration} ease-in-out;
    `};
`;

const LightPurpleBackground = styled.img`
  margin-left: 50%;
  position: absolute;
  top: 828px;
  transform: translate3d(100%, 0, 0);
  width: 2560px;

  ${({ animateLightPurpleBackgroundSVG, animationDuration }) =>
    animateLightPurpleBackgroundSVG &&
    css`
      transform: translate3d(-50%, 0, 0);
      transition: transform ${animationDuration} ease-in-out;
    `};
`;

const PurpleTriangleYellowCircleBlob = styled.img`
  position: absolute;
  top: -200px;
  left: 0;
`;

const YellowCircleBlueSwooshBlobSVGBlob = styled.img`
  position: absolute;
  top: 600px;
  right: 0;
`;

const YellowTriangleRedCircleSVGBlob = styled.img`
  position: absolute;
  left: 0;
  top: 425px;
`;

export const query = graphql`
  query ($title: String!) {
    venue: markdownRemark(frontmatter: { title: { eq: $title } }) {
      id
      html
      frontmatter {
        title
        summary
        metaTagOverrides {
          title
          description
        }
        pardotRedirectLinkForBrochure
        venuePartnerWebsite
        featuredImg {
          alt
          src {
            name
            childImageSharp {
              gatsbyImageData(
                width: 1440
                transformOptions: { cropFocus: CENTER }
                quality: 50
                pngOptions: { compressionSpeed: 10 }
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
        }
        carouselImgs {
          alt
          src {
            childImageSharp {
              gatsbyImageData(
                width: 710
                height: 710
                transformOptions: { cropFocus: CENTER }
                quality: 65
                pngOptions: { compressionSpeed: 10 }
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
        }
        services {
          teamBuilding
          countryPursuits
          irishActivities
          companyAndEveningEntertainment
          eventManagement
        }
        specificTestimonials {
          title
          personsName
          companyLogo {
            childImageSharp {
              gatsbyImageData(
                width: 60
                height: 60
                transformOptions: { fit: CONTAIN }
                quality: 50
                backgroundColor: "transparent"
                pngOptions: { compressionSpeed: 10 }
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
          quote
        }
      }
    }
    cards: allFile(
      filter: { sourceInstanceName: { eq: "cms_data_venue_partners" }, ext: { eq: ".md" } }
      limit: 10
    ) {
      edges {
        node {
          childMarkdownRemark {
            frontmatter {
              title
              summary
              featuredImg {
                alt
                src {
                  childImageSharp {
                    gatsbyImageData(
                      width: 268
                      height: 340
                      transformOptions: { cropFocus: CENTER }
                      quality: 40
                      pngOptions: { compressionSpeed: 10 }
                      placeholder: BLURRED
                    )
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default sizes(({ width }) => ({ viewportWidth: width && width }))(Venue);
